// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_co-b";
export var colorBlue = "_co-8";
export var colorDot = "_co-0";
export var colorDotLarge = "_co-2";
export var colorDotSmall = "_co-1";
export var colorGreen = "_co-7";
export var colorGrey = "_co-3";
export var colorOrange = "_co-5";
export var colorPink = "_co-a";
export var colorPurple = "_co-9";
export var colorRed = "_co-4";
export var colorYellow = "_co-6";